import { Component, NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AuthGuard } from "./../app/_app-core/_guards/auth-guard.guard";
import { FormGuard } from "./_app-core/_guards/form.guard";

import { GetStartedComponent } from "./_pages/account/get-started/get-started.component";
import { SelectLanguageComponent } from "./_pages/account/select-language/select-language.component";
import { VendorMasterDataComponent } from "./_pages/account/vendor-master-data/vendor-master-data.component";
import { SupplierHomeComponent } from "./_pages/supplier/supplier-home/supplier-home.component";
import { SupplierChangePasswordComponent } from "./_pages/account/supplier-change-password/supplier-change-password.component";
import { PurchaseOrdersComponent } from "./_pages/supplier/purchase-orders/purchase-orders.component";
import { ProofOfDeliveryComponent } from "./_pages/supplier/proof-of-delivery/proof-of-delivery.component";
import { InvoicesComponent } from "./_pages/supplier/invoices/invoices.component";
import { InvoiceSubmissionComponent } from "./_pages/supplier/invoice-submission/invoice-submission.component";
import { UploadPreviewComponent } from "./_pages/supplier/upload-preview/upload-preview.component";
import { SignInComponent } from "./_pages/account/sign-in/sign-in.component";
import { ResetPasswordComponent } from "./_pages/account/reset-password/reset-password.component";
import { ResetPasswordLangingPageComponent } from "./_pages/account/reset-password-langing-page/reset-password-langing-page.component";
import { VendorProfileComponent } from "./_pages/supplier/vendor-profile/vendor-profile.component";
import { CreditNotesComponent } from "./_pages/supplier/credit-debit-notes/credit-notes/credit-notes.component";
import { CreditNoteDetailComponent } from "./_pages/supplier/credit-debit-notes/credit-note-detail/credit-note-detail.component";
import { CreditNoteUploadPreviewComponent } from "./_pages/supplier/credit-debit-notes/credit-note-upload-preview/credit-note-upload-preview.component";
import { UploadCreditNoteComponent } from "./_pages/supplier/credit-debit-notes/upload-credit-note/upload-credit-note.component";
import { SubmitNonpoInvoiceComponent } from "./_pages/supplier/submit-nonpo-invoice/submit-nonpo-invoice.component";
import { InvoiceDetailComponent } from "./_pages/supplier/invoice-detail/invoice-detail.component";
import { ProofOfDeliveryServiceComponent } from "./_pages/supplier/proof-of-delivery-service/proof-of-delivery-service.component";
import { PoDetailsComponent } from "./_pages/supplier/po-details/po-details.component";
import { UploadPreviewNonpoComponent } from "./_pages/supplier/upload-preview-nonpo/upload-preview-nonpo.component";
import { ChangePasswordComponent } from "./_pages/supplier/change-password/change-password.component";
import { SavedInvoicesComponent } from "./_pages/supplier/saved-invoices/saved-invoices.component";
import { SavedInvoicesNonpoComponent } from "./_pages/supplier/saved-invoices-nonpo/saved-invoices-nonpo.component";
import { SavedInvoicesPosComponent } from "./_pages/supplier/saved-invoices-pos/saved-invoices-pos.component";
import { UploadPreviewDigitalInvoiceComponent } from "./_pages/supplier/upload-preview-digital-invoice/upload-preview-digital-invoice.component";
import { UploadPreviewNonpoDigitalInvoiceComponent } from "./_pages/supplier/upload-preview-nonpo-digital-invoice/upload-preview-nonpo-digital-invoice.component";
import { UploadPreviewLogisticsDigitalInvoiceComponent } from "./_pages/supplier/upload-preview-logistics-digital-invoice/upload-preview-logistics-digital-invoice.component";
import { SubmitLogisticsComponent } from "./_pages/supplier/submit-logistics/submit-logistics.component";
import { UploadPreviewLogisticsComponent } from "./_pages/supplier/upload-preview-logistics/upload-preview-logistics.component";
import { DsCreditNoteUploadPreviewComponent } from "./_pages/supplier/credit-debit-notes/ds-credit-note-upload-preview/ds-credit-note-upload-preview.component";
import { ViewGrnComponent } from "./_pages/supplier/view-grn/view-grn.component";
import { ImpersonateComponent } from "./_pages/account/impersonate/impersonate.component";
import { ExitImpersonationComponent } from "./_pages/account/exit-impersonation/exit-impersonation.component";
import { LedgerPreviewComponent } from "./_pages/supplier/credit-debit-notes/ledger-preview/ledger-preview.component";
import { LedgerUploadComponent } from "./_pages/supplier/credit-debit-notes/ledger-upload/ledger-upload.component";
import { DsLedgerPreviewComponent } from "./_pages/supplier/credit-debit-notes/ds-ledger-preview/ds-ledger-preview.component";
import { QueriesComponent } from "./_pages/supplier/query-management/queries/queries.component";
import { QueryDetailComponent } from "./_pages/supplier/query-management/query-detail/query-detail.component";
import { SubmitQueryComponent } from "./_pages/supplier/query-management/submit-query/submit-query.component";
import { EditQueryComponent } from "./_pages/supplier/query-management/edit-query/edit-query.component";
import { VendorRegistrationComponent } from "./_pages/supplier/vendor-registration/vendor-registration.component";

const routes: Routes = [
    {
        path: "",
        component: SignInComponent,
    },
    {
        path: "get-started",
        component: SignInComponent,
    },
    {
        path: "select-language",
        component: SelectLanguageComponent,
    },
    {
        path: "vendor-master-data",
        component: VendorMasterDataComponent,
    },
    {
        path: "password-change-onboarding",
        component: SupplierChangePasswordComponent,
    },
    {
        path: "portal-exit",
        component: ExitImpersonationComponent,
    },
    {
        path: "dashboard",
        component: SupplierHomeComponent,
        canActivate: [AuthGuard],
    },
    {
        path: "purchase-orders",
        component: PurchaseOrdersComponent,
        canActivate: [AuthGuard],
    },
    {
        path: "view-grn/:poNo",
        component: ViewGrnComponent,
        canActivate: [AuthGuard],
    },
    {
        path: "proof-of-delivery/:poNo",
        component: ProofOfDeliveryComponent,
        canActivate: [AuthGuard],
    },
    {
        path: "po-line-items/:poNo",
        component: ProofOfDeliveryServiceComponent,
        canActivate: [AuthGuard],
    },
    {
        path: "manage-queries",
        component: QueriesComponent,
        canActivate: [AuthGuard],
    },
    {
        path: "query-detail/:queryNo",
        component: QueryDetailComponent,
        canActivate: [AuthGuard],
    },
    {
        path: "submit-query",
        component: SubmitQueryComponent,
        canActivate: [AuthGuard],
    },
    {
        path: "edit-query/:queryNo",
        component: EditQueryComponent,
        canActivate: [AuthGuard],
    },
    {
        path: "invoices",
        component: InvoicesComponent,
        canActivate: [AuthGuard],
    },
    {
        path: "saved-invoices",
        component: SavedInvoicesComponent,
        canActivate: [AuthGuard],
    },
    {
        path: "submit-invoice/:poNo",
        component: InvoiceSubmissionComponent,
        canActivate: [AuthGuard],
    },
    {
        path: "submit-nonpo-invoice",
        component: SubmitNonpoInvoiceComponent,
        canActivate: [AuthGuard],
    },
    {
        path: "submit-logistics-invoice",
        component: SubmitLogisticsComponent,
        canActivate: [AuthGuard],
    },
    {
        path: "submit-ledger",
        component: LedgerUploadComponent,
        canActivate: [AuthGuard],
    },
    {
        path: "invoice-preview/:poNo",
        component: UploadPreviewComponent,
        canActivate: [AuthGuard],
        canDeactivate: [FormGuard],
    },
    {
        path: "invoice-preview-digital-invoice/:poNo",
        component: UploadPreviewDigitalInvoiceComponent,
        canActivate: [AuthGuard],
        canDeactivate: [FormGuard],
    },
    {
        path: "invoice-preview-logistics",
        component: UploadPreviewLogisticsComponent,
        canActivate: [AuthGuard],
        canDeactivate: [FormGuard],
    },
    {
        path: "digital-invoice-preview-logistics",
        component: UploadPreviewLogisticsDigitalInvoiceComponent,
        canActivate: [AuthGuard],
        canDeactivate: [FormGuard],
    },
    {
        path: "invoice-preview-nonpo",
        component: UploadPreviewNonpoComponent,
        canActivate: [AuthGuard],
        canDeactivate: [FormGuard],
    },
    {
        path: "invoice-preview-digital-invoice-nonpo",
        component: UploadPreviewNonpoDigitalInvoiceComponent,
        canActivate: [AuthGuard],
        canDeactivate: [FormGuard],
    },
    {
        path: "ledger-preview",
        component: LedgerPreviewComponent,
        canActivate: [AuthGuard],
        canDeactivate: [FormGuard],
    },
    {
        path: "digitally-signed-ledger-preview",
        component: DsLedgerPreviewComponent,
        canActivate: [AuthGuard],
        canDeactivate: [FormGuard],
    },
    {
        path: "credit-note-preview/:itemNo",
        component: CreditNoteUploadPreviewComponent,
        canActivate: [AuthGuard],
        canDeactivate: [FormGuard],
    },
    {
        path: "credit-note-preview-digital-invoice/:itemNo",
        component: DsCreditNoteUploadPreviewComponent,
        canActivate: [AuthGuard],
        canDeactivate: [FormGuard],
    },
    {
        path: "forgot-password",
        component: ResetPasswordComponent,
    },
    {
        path: "reset-password",
        component: ResetPasswordLangingPageComponent,
    },
    {
        path: "manage-user",
        component: ImpersonateComponent,
    },
    // {
    //     path: "sign-in",
    //     component: SignInComponent,
    // },
    {
        path: "credit-notes",
        component: CreditNotesComponent,
    },
    {
        path: "vendor-profile",
        component: VendorProfileComponent,
        canActivate: [AuthGuard],
    },
    {
        path: "vendor-registration/:base64Str",
        component: VendorRegistrationComponent,
        // canActivate: [AuthGuard],
    },
    {
        path: "upload-credit-note/:poNo",
        component: UploadCreditNoteComponent,
        canActivate: [AuthGuard],
    },
    {
        path: "credit-note-detail/:barcode",
        component: CreditNoteDetailComponent,
        canActivate: [AuthGuard],
    },
    {
        path: "invoice-detail/:barcode",
        component: InvoiceDetailComponent,
        canActivate: [AuthGuard],
    },
    {
        path: "purchase-order-detail/:poNo",
        component: PoDetailsComponent,
        canActivate: [AuthGuard],
    },
    {
        path: "invoice-update-nonpo/:irn",
        component: SavedInvoicesNonpoComponent,
        canActivate: [AuthGuard],
    },
    {
        path: "invoice-update/:irn",
        component: SavedInvoicesPosComponent,
        canActivate: [AuthGuard],
    },
    {
        path: "change-password",
        component: ChangePasswordComponent,
        canActivate: [AuthGuard],
    },
    {
        path: "return",
        redirectTo: "",
        pathMatch: "full",
    },
    {
        path: "**",
        redirectTo: "",
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            useHash: true,
            scrollPositionRestoration: "enabled",
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
